import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getRecurringProfiles = ({ queryKey }: any) => {
  return http.get("/recurring-profile", { params: { ...queryKey[1] } });
};

const bulkImportRecurringTasks = (data: FormData) => {
  return cronHttp.post("/recurring-profile/bulk-import", data);
};

const getBulkImportJobs = () => {
  return http.get("/recurring-profile/bulk-import");
};

const getBulkImportJob = ({ queryKey }: any) => {
  return http.get(`/recurring-profile/bulk-import/${queryKey[1]}`);
};

const getJobErrors = ({ queryKey }: any) => {
  return http.get(`/recurring-profile/bulk-import/${queryKey[1]}/errors`);
};

const downloadJobErrors = (jobId: number) => {
  return http.get(`/recurring-profile/bulk-import/${jobId}/errors/download`, {
    responseType: "arraybuffer",
  });
};

const getRecurringProfilesTasks = ({ queryKey }: any) => {
  return http.get("/recurring-profile/task", { params: { ...queryKey[1] } });
};

const updateRecurringTask = ({ sendData, data }: any) => {
  return http.patch(`/recurring-profile/tasks/${data.id}`, sendData);
};

const updateRecurringProfile = ({ id, data }: any) => {
  return http.patch(`/recurring-profile/${id}`, data);
};

const terminateRecurringProfile = ({ id }: any) => {
  return http.post(`/recurring-profile/${id}/terminate`);
};

export {
  getRecurringProfiles,
  updateRecurringProfile,
  terminateRecurringProfile,
  updateRecurringTask,
  getRecurringProfilesTasks,
  bulkImportRecurringTasks,
  getBulkImportJobs,
  getBulkImportJob,
  getJobErrors,
  downloadJobErrors,
};
